import {createInstance} from "@/util/sdkLoader";
import config from "@/config";
import * as apiUtils from "@/util/api";
import SharetribeSdk from "@server/v2/sharetribe/types/SharetribeSdk.ts";

const baseUrl = config.sdk.baseUrl ? { baseUrl: config.sdk.baseUrl } : {};
const assetCdnBaseUrl = config.sdk.assetCdnBaseUrl
  ? { assetCdnBaseUrl: config.sdk.assetCdnBaseUrl }
  : {};

// Sharetribe sdk for client-side app
export default createInstance({
  transitVerbose: config.sdk.transitVerbose,
  clientId: config.sdk.clientId,
  secure: config.usingSSL,
  typeHandlers: apiUtils.typeHandlers,
  ...baseUrl,
  ...assetCdnBaseUrl,
}) as SharetribeSdk;
